import { prop } from 'ramda';
import peoplePickerManager from '../peopleSearches/peoplePickerManager';
import AsyncDialog from './asyncDialog';
import {
    PROMPTBOX_RESULT_YES,
    PROMPTBOX_TYPE_YESNO,
    showPromptBox,
} from './promptBox';

// TODO: Use constants for element class names

const $ = window.jQuery;

const SELECT_WIDTH = '100%';
const select2MultOptions = {
    width: SELECT_WIDTH,
};
const select2Options = {
    width: SELECT_WIDTH,
    placeholder: '',
    allowClear: true,
};

const noPeopleFoundMessage = 'No matching users found.';

const isEnterEvent = (e) => e && (e.keyCode === 13 || e.code === 'Enter');

function peopleSelector(qfsAccess, siteUrl, peopleSearcher) {
    var pickerManagerInst = peoplePickerManager(qfsAccess);
    var searchPeopleOnly;
    var allowMultiple;
    var isAddressBook;

    var maxCount = 200;
    var providers;

    var peoplePickerDialog;

    // 2023-11-24 - Removed unused getProviderByName()

    // 2018-04-18 - Removed unused getDefaultProviderOption()

    function formatResults(items) {
        return items.map(function (item) {
            // setting item.text so that the select2 control in the form's view will display the user's DisplayName
            return { ...item, text: item.DisplayName };
        });
    }

    function showSearchError(divErrMsg, err) {
        divErrMsg.text(err).show();
    }

    const makeSelector = (multiple) => {
        let selector = $('<select class="search-selector">');

        if (multiple) {
            selector.prop('multiple', true);
            selector.prop('size', 4);
        }

        return selector;
    };

    const makeSelectorDiv = (
        multiple,
        phSelectHeading,
        ddlSelector,
        divAddUsers,
    ) => {
        let divSelector = $('<div id="divSelector" class="hidden">');

        if (multiple) {
            divSelector.append(phSelectHeading);
        }

        divSelector.append(ddlSelector);

        if (multiple) {
            divSelector.append(divAddUsers);
        }

        return divSelector;
    };

    function makeUi() {
        const title = 'Person' + (searchPeopleOnly ? '' : '/Group') + ' Picker';

        let phSelectHeading = $("<p id='phSelectHeading'>Select Users</p>");

        let ddlSelector = makeSelector(allowMultiple);

        let divAddUsers = $(
            `<div class='add' class="hidden"><input type='button' value='Add Selected User(s)' aria-label="Add selected user or users" /></div>`,
        );

        let divSelector = makeSelectorDiv(
            allowMultiple,
            phSelectHeading,
            ddlSelector,
            divAddUsers,
        );

        let phResultHeading = $("<p id='phResultHeading'>Selected Users</p>");

        // contains chosen results when in multi-person mode
        let ddlResult = $('<select class="search-result">');
        let divResult = $('<div id="divResult" class="hidden">')
            .append(phResultHeading)
            .append(ddlResult);

        var divErrMsg = $(
            "<div class='hidden err-msg'>No matching users found.</div>",
        );

        var btnContainer = $("<div class='btn-container'>")
            .append(
                $("<div class='buttons ok'>").append(
                    AsyncDialog.makeButton('OK', 'ok'),
                ),
            )
            .append(
                $("<div class='buttons cancel'>").append(
                    AsyncDialog.makeButton('Cancel', 'cancel'),
                ),
            );

        var msgDiv = $('<div>').attr('title', title);

        if (!isAddressBook) {
            btnContainer.addClass('hidden');
        }

        msgDiv
            .append($('<input class="inp-search" title="Person search text">'))
            .append(
                $(
                    "<div class='buttons search'><button class='ppl-search-button' title='Search'><img src='/images/search.png' alt='Search Icon' /></button></div>",
                ),
            )
            .append(divErrMsg);

        if (isAddressBook) {
            msgDiv.append(divSelector);
        }

        function handleFailedSearch() {
            showSearchError(divErrMsg, noPeopleFoundMessage);

            divSelector.hide();
        }

        // Fills the results dropdown with the specified data
        // Used when performing a non-addressbook search (which isn't used as of 2025-01-30)
        function setResults(data) {
            ddlResult.html('');
            ddlResult.select2({
                data: data,
                width: '99%',
            });
        }

        // display text is determined in peoplePickerManager, so changes to how it is determined
        // should be made there
        const itemDisplayText = prop('text');

        function populateSelector(data) {
            divSelector.show();

            ddlSelector.html('');
            ddlSelector.append(
                data.map((item) =>
                    $('<option>')
                        .val(JSON.stringify(item))
                        .text(itemDisplayText(item)),
                ),
            );
        }

        function showResultSection() {
            if (allowMultiple) {
                if (divResult.is(':hidden')) {
                    ddlResult.select2({
                        multiple: 'multiple',
                        width: '99%',
                    });
                }
            }

            divResult.show();
        }

        function handleAddressBookSearchResult(data) {
            // important to clear selector especially if the search result is empty
            // so that confirming the dialog doesn't use the previous search result
            ddlSelector.val('');

            if (!data || !data.length) {
                handleFailedSearch();

                return;
            }

            phResultHeading.text(
                allowMultiple ? 'Selected users' : 'Select user',
            );

            populateSelector(data);

            if (allowMultiple) {
                showResultSection();
            }
        }

        const getSelect2Data = () =>
            ddlResult.val() ? ddlResult.select2('data') : [];

        function handleNonAddressBookSearchResult(data) {
            if (!data || !data.length) {
                showSearchError(divErrMsg, noPeopleFoundMessage);
            } else if (data.length === 1) {
                setResults(data);

                var result = getSelect2Data(ddlResult);

                return peoplePickerDialog.closeWithResult({ values: result });
            } else {
                setResults(data);

                divResult.show();
                btnContainer.show();
            }

            return Promise.resolve();
        }

        const getSelectedPeople = () => {
            if (allowMultiple) {
                return getSelect2Data(ddlResult);
            }

            const selectorValue = ddlSelector.val();

            return selectorValue ? [JSON.parse(selectorValue)] : [];
        };

        const findParentDialog = (start) =>
            $(start).closest('.fv-people-selector-dialog');

        const addressBookSearch = async (searchText) => {
            const data = await peopleSearcher.searchPeople(
                searchText,
                searchPeopleOnly,
                maxCount,
            );

            handleAddressBookSearchResult(data);
        };

        const nonAddressBookSearch = async (searchText) => {
            const listProviders = null;

            const data = await pickerManagerInst.searchUserNameAsync(
                siteUrl,
                // BUGBUG - listProviders is not actually defined anywhere. adding a constant
                //          for it above so that this file passes lint
                listProviders,
                searchText,
                searchPeopleOnly,
            );

            handleNonAddressBookSearchResult(data);
        };

        const search = async ($dialogDiv) => {
            divErrMsg.hide();

            const searchText = $dialogDiv.find('.inp-search').val();

            if (!searchText) {
                alert('Please enter a search term.');
                return;
            }

            try {
                if (isAddressBook) {
                    await addressBookSearch(searchText);
                } else {
                    await nonAddressBookSearch(searchText);
                }
            } catch (e) {
                showSearchError(divErrMsg, e.message);

                if (allowMultiple) {
                    divSelector.hide();
                } else {
                    divResult.hide();
                }
            }
        };

        msgDiv
            .append(divResult)
            .append(btnContainer)
            .on('click', '.add', function () {
                const selectedVal = ddlSelector.val();
                const selectedItems = selectedVal
                    ? selectedVal.map(JSON.parse)
                    : [];

                if (!selectedItems.length) {
                    return;
                }

                const selectedResult = getSelect2Data(ddlResult);

                const allItems = selectedResult.concat(
                    selectedItems.filter(function (item) {
                        return !selectedResult.some(function (res) {
                            return item.AccountId === res.AccountId;
                        });
                    }),
                );

                ddlResult
                    .html('')
                    .select2({
                        multiple: 'multiple',
                        width: '99%',
                        data: allItems,
                    })
                    .val(allItems.map(prop('value')))
                    .trigger('change');
            })
            .on('click', '.ppl-search-button', async (e) => {
                await search(findParentDialog(e.target));
            })
            .on('click', 'div.buttons.cancel', function () {
                return peoplePickerDialog.closeWithResult({ canceled: true });
            })
            .on('click', 'div.buttons.ok', async function () {
                try {
                    const selectedItems = getSelectedPeople();

                    if (selectedItems.length) {
                        peoplePickerDialog.closeWithResult({
                            values: formatResults(selectedItems),
                        });

                        return;
                    }

                    const promptText = `You have not selected any people. ${
                        allowMultiple
                            ? `Do you wish to proceed?`
                            : `Do you wish to clear the people picker?`
                    }`;

                    const promptResult = await showPromptBox({
                        title: 'No people selected',
                        text: promptText,
                        type: PROMPTBOX_TYPE_YESNO,
                    });

                    if (promptResult === PROMPTBOX_RESULT_YES) {
                        peoplePickerDialog.closeWithResult({ values: [] });
                    }
                } catch (e) {
                    console.error(e);
                }
            })
            .on('keydown', '.inp-search', async (e) => {
                if (!isEnterEvent(e)) {
                    return;
                }

                await search(findParentDialog(e.target));
            });

        return msgDiv;
    }

    function showPeopleDialog() {
        peoplePickerDialog = new AsyncDialog();
        peoplePickerDialog.class = 'fv-people-selector-dialog';
        peoplePickerDialog.autoFocusControl = '.inp-search';
        peoplePickerDialog.setTarget(makeUi());
        peoplePickerDialog.width = 600;

        return peoplePickerDialog.showAsync();
    }

    function searchAddressBookAsync(eventInfo) {
        isAddressBook = true;

        searchPeopleOnly = eventInfo.searchPeopleOnly;
        allowMultiple = eventInfo.allowMultiple;

        return showPeopleDialog();
    }

    function checkUserNameAsync(eventInfo) {
        isAddressBook = false;

        searchPeopleOnly = eventInfo.searchPeopleOnly;
        allowMultiple = eventInfo.allowMultiple;

        return pickerManagerInst
            .checkIsClaimsModeAsync(siteUrl)
            .then(function (data) {
                if (data) {
                    return pickerManagerInst.getClaimProviderSchemasAsync(
                        siteUrl,
                    );
                }

                return null;
            })
            .then(function (data) {
                if (data && data.length) {
                    providers = data;
                }
            })
            .then(function () {
                if (!providers.length) {
                    return null;
                }

                return showPeopleDialog();
            });
    }

    const getSelect2Options = (isMulti) => ({
        ...(isMulti ? select2MultOptions : select2Options),
    });

    return {
        searchAddressBookAsync,
        checkUserNameAsync,
        select2Options,
        select2MultOptions,
        getSelect2Options,
    };
}

export default peopleSelector;
